export default "./dist/stdassets/images/icons/help.png";